import { Reducer } from 'redux';
import { Action, ActionType } from '../../actions';
import { BusinessData } from '../../state/BusinessData/BusinessData';

const updateBusinessData: Reducer<BusinessData> = (state: BusinessData = new BusinessData(), action: Action<ActionType, BusinessData>) => {
  switch (action.type) {
    case ActionType.BUSINESS_DATA_RELEVANCES_UPDATED:
      return { ...state, relevances: [...action.data] };
    case ActionType.BUSINESS_DATA_BRAND_AND_MARKETS_UPDATED:
      return { ...state, brandAndMarkets: [...action.data] };
    case ActionType.BUSINESS_DATA_CABIN_TYPES_UPDATED:
      return { ...state, cabinTypes: [...action.data] };
    case ActionType.BUSINESS_DATA_JOURNEY_TYPES_UPDATED:
      return { ...state, journeyTypes: [...action.data] };
    default:
      return state;
  }
};

export default updateBusinessData;
